
// XXX_INTERNAL - allows to connect directly to another docker container. Will not work with Client Side Render !!!
// XXX_EXTERNAL - allows to connect to endpoint via domain. Will work both with SSR (avoid using) and CSR.
// XXX_NODE     - connects to node endpoint and exists only for frontend purposes.

export const API_APP_INTERNAL = process.env.NEXT_PUBLIC_API_APP_INTERNAL;
export const API_APP_EXTERNAL = process.env.NEXT_PUBLIC_API_APP_EXTERNAL;
export const API_APP_NODE = `/api/app`;
//------------------
//           Info
//------------------
export const API_STACK_LIST_INTERNAL = `${API_APP_INTERNAL}/stacks/search`;
//        --
export const API_CLOUDS_CURRENCIES_CATEGORIES_INTERNAL = `${API_APP_INTERNAL}/info/`;
//        --
export const API_QUESTIONNAIRE_DATA_INTERNAL = `${API_APP_INTERNAL}/settings/`;
export const API_QUESTIONNAIRE_DATA_NODE = `${API_APP_NODE}/questionnaire`;
//------------------
//           Request feature
//------------------
export const API_CUSTOM_REQUEST_INTERNAL = `${API_APP_INTERNAL}/request/`;
export const API_CUSTOM_REQUEST_NODE = `${API_APP_NODE}/request-desire`;
//------------------
//           Blog
//------------------
export const API_ARTICLES_INTERNAL = `${API_APP_INTERNAL}/blog/articles`;